export const CHAPTERS = [
  {
    n: '01', slug: 'genesis', title: 'Genesis', color: '#B50A00',
    keys: 'Premise · Scope · Direction',
    tag: 'Why this project exists, the premise, the brief, and the road map.',
    img: '/assets/book/new-photo3.jpg',
    canopy: '#8F0800',
  },
  {
    n: '02', slug: 'context', title: 'Context', color: '#FF7E00',
    keys: 'Landscape · Forces · Gap',
    tag: 'Quick commerce pressure, the retail landscape, and the big crack.',
    img: '/assets/book/field-bkstore.jpg',
    canopy: '#D96A00',
  },
  {
    n: '03', slug: 'discovery', title: 'Discovery', color: '#FFB000',
    keys: 'Field · Behaviour · Reality',
    tag: 'Twelve steps on the ground, conversations, workflows, artefacts.',
    img: '/assets/book/img-p109-22259.jpg',
    canopy: '#D99800',
  },
  {
    n: '04', slug: 'synthesize', title: 'Synthesize', color: '#20431B',
    keys: 'Patterns · Insights · Defining',
    tag: 'From 134 raw notes to a sharp, buildable design brief.',
    img: '/assets/book/new-photo2.jpg',
    canopy: '#173312',
  },
  {
    n: '05', slug: 'resolution', title: 'Resolution', color: '#01114F',
    keys: 'Construction · Strategy · Delivery',
    tag: 'The 3-Layer Approach and the system around it, then the framework, imagined.',
    img: '/assets/book/img-p247-45345.jpg',
    canopy: '#020D38',
  },
];

export const EASE = [0.16, 1, 0.3, 1];
